import { showErrorAlert } from "./alert";

export const getAccessToken = () => {
  let token = null;
  if (typeof window !== "undefined") {
    token = parseData(sessionStorage.getItem("auth_token"));
    return token;
  }
  return token;
};

export const stringifyData = (obj) => {
  if (!obj) return "";

  return JSON.stringify(obj);
};

export const parseData = (str) => {
  if (!str) return {};

  return JSON.parse(str);
};

export const internetCheck = () => {
  if (!navigator.onLine) {
    showErrorAlert("Network error, check your internet");

    return;
  }

  return true;
};

export const convertTime12to24 = (time12h) => {
  const [time, modifier] = time12h.split(" ");

  let [hours, minutes] = time.split(":");

  if (hours === "12") {
    hours = "00";
  }

  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  }

  return `${hours}:${minutes}`;
};

export const calcTime = (dateObj, convertTimeto24 = false) => {
  let d = dateObj ? new Date(dateObj) : new Date();
  let options = {
    hour: "2-digit",
    minute: "2-digit",
  };

  const timeWith_AM_PM = d.toLocaleTimeString("en-US", options);

  if (convertTimeto24) {
    return convertTime12to24(timeWith_AM_PM);
  } else {
    return timeWith_AM_PM;
  }
};

export function tConvert(time) {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
}

export const FormatAmount = (amount, koboRes = true) => {
  if (!amount) return "0.00";
  //ensure all commas are striped from the amount
  amount = String(amount).replace(/,/g, "");
  //split the amount into naira and kobo
  //format the naira and add the kobo at the end of the process
  amount = String(amount).split(".");
  let naira = amount[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  let kobo = String(amount[1]);
  if (!kobo || kobo === "undefined") kobo = "00";
  if (kobo && kobo.length === 1) kobo = kobo + "0";
  if (kobo && kobo.length > 1) kobo = kobo.substring(0, 2);
  return koboRes ? `${naira}.${kobo}` : naira;
};

export const removeEntriesData = (string) => {
  const result = { fullName: "", date: "", time: "", location: "" };
  result.fullName = extractName(string);
  result.date = extractDate(string).substring(11);
  result.time = extractTime(string);
  result.location = extractLocation(string).substring(3);

  return result;
};

export function extractName(inputString) {
  // Use a regular expression to match the name
  const namePattern = /([A-Za-z]+ [A-Za-z]+)/;
  const match = inputString.match(namePattern);

  // If a match is found, return the name; otherwise, return null
  return match ? match[1] : null;
}

export function extractDate(str) {
  const datePattern = /\b\d{2}\/\d{2}\/\d{4} \d{2}:\d{2} [APM]{2}\b/;
  const match = str.match(datePattern);
  return match ? match[0] : null;
}

export function extractTime(str) {
  const timePattern = /\b\d{2}:\d{2} [APM]{2}\b/;
  const match = str.match(timePattern);
  return match ? match[0] : null;
}

export function extractLocation(str) {
  const locationPattern = /\bat .*/;
  const match = str.match(locationPattern);
  return match ? match[0] : null;}


export function getRemainingInfo(inputString) {
  const namePattern = /([A-Za-z]+ [A-Za-z]+)/;
  const match = inputString.match(namePattern);

  if (match) {
    const name = match[0];
    const remainingInfo = inputString.replace(name, "").trim();
    return remainingInfo;
  } else {
    return inputString.trim();  
  }
}

export function clockSwitch(message) {
  if (checkArrived(message)) {
    return "clock in";
  } else {
    return "clock out";
  }
}
function checkArrived(message) {
  const lowerCaseMessage = message.toLowerCase();
  return lowerCaseMessage.includes("arrived");
}

	export const FormatDate = (date, hideTime, dayFirst) => {
		date = new Date(date);
		const monthNames = [
		  "January",
		  "Febuary",
		  "March",
		  "April",
		  "May",
		  "June",
		  "July",
		  "August",
		  "September",
		  "October",
		  "November",
		  "December"
		];
	  
		var day = date.getDate();
		var monthIndex = date.getMonth();
		var year = date.getFullYear();
		var hours = date.getHours();
		var mins = date.getMinutes();
		var secs = date.getSeconds();
	  
		if (day < 10) day = `0${day}`;
		if (hours < 10) hours = `0${hours}`;
		if (mins < 10) mins = `0${mins}`;
		if (secs < 10) secs = `0${secs}`;
	  
		//CHECK IF DATE HAS TIME
		if ((hours === "00" && mins === "00" && secs === "00") || hideTime)
		  return dayFirst
			? `${day} ${monthNames[monthIndex]}, ${year}`
			: `${monthNames[monthIndex]} ${day}, ${year}`;
		return dayFirst
		  ? `${day} ${monthNames[monthIndex]}, ${year} ${hours}:${mins}:${secs}`
		  : `${monthNames[monthIndex]} ${day}, ${year} ${hours}:${mins}:${secs}`;
	  };
	  
	  export const numericFormat = (
		date,
		time,
		dayFirst,
		divider = "-",
		onlyYear,
		monthFirst,
		add1Day
	  ) => {
		if (!date) return;
		let newDate = new Date(date);
		let day = add1Day ? newDate.getDate() + 1 : newDate.getDate();
		let month = newDate.getMonth() + 1;
		let year = newDate.getFullYear();
		//add an extra zero in front of day and month if it's single digits
		if (day < 10) day = `0${day}`;
		if (month < 10) month = `0${month}`;
		if (onlyYear) return year;
		if (time) return new Date(`${year}${divider}${month}${divider}${day}T23:59:59Z`);
		if (dayFirst) return `${day}${divider}${month}${divider}${year}`;
		if (monthFirst) return `${month}${divider}${day}${divider}${year}`;
	  
		return `${year}${divider}${month}${divider}${day}`;
	  };

    export const getTodaysDate = (showMntName=true) => {
      let d = new Date();
      const monthNames = [
        "January",
        "Febuary",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
  

      var day = d.getDate();
      var monthIndex = d.getMonth();
      let month = d.getMonth() + 1;
      var year = d.getFullYear();

      return showMntName ? `${monthNames[monthIndex]} ${day}, ${year}` : `${year}-${month}-${day}`
  
    }
	  